<template>
  <div>
  
    
    <b-row >
       
  <!----- SideBar All Design List ---->
   <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
  <!----- SideBar All Design List End ----> 
  
     <div class="design-container-details__main" style="width:79%">
        <div class="brand-card" >

          <div class="col-md-12" style="margin-top:10px;margin-bottom:10px;">
            <div class="col-md-12">Design Title:<strong> &nbsp;{{style_details.design_title}}</strong> </div>
              <div class="col-md-12">Style Name : &nbsp;{{style_details.style_name}} >> {{style_details.sub_cattitle}}</div>
              <div class="col-md-12">Created Date : {{style_details.created_date }} </div>
              <div class="col-md-12">Buyer Name : {{style_details.buyer_name }} </div>
          </div>

<!-- Code For Tab -->
<navbarMenu></navbarMenu>
<br>

<!-- Code For Tab Ends -->
                      <!-- <b-col sm="12"> -->
        <!-- <b-card> -->
          <div class="col-md-12">

          <div class="col-md-12">
          <b-col sm="12">
                <label><b>Vendor Name &nbsp;:</b>{{selectedvendorname}}</label>&nbsp;&nbsp;&nbsp;&nbsp;
              
                <label><b>Buyer Name&nbsp;:</b>{{selectedbuyername}}</label>&nbsp;&nbsp;&nbsp;&nbsp;
              
                <label><b>Status&nbsp;:</b>{{selectedstatus}}</label>&nbsp;&nbsp;&nbsp;&nbsp;
             </b-col>
           </div>

               <ul class="nav nav-tabs">
            <li class="nav-item">
              <router-link :to="'/design_purchaseorder/'+ route_id " class="nav-link " data-toggle="pill">
               Purchase Order 
            
            </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link :to="'/fcplm_vendor/poform/' " class="nav-link " data-toggle="pill">
              Po form 
            
            </router-link>
            </li> -->
             <li class="nav-item">
             <router-link :to="'/qc_executive_tna/'+ route_id " class="nav-link " data-toggle="pill">
              TNA   
            
            </router-link>
            </li>
            <li class="nav-item">
             <router-link :to="'/design_po_reports/' + route_id" class="nav-link " data-toggle="pill">
              Reports   
            
            </router-link>
            </li>
           
             
          </ul> 
          </div> 
          <br><br> 


   
<!-- <div class="col-md-12"> -->
              <!-- <div class="col-md-12">
              <label style="float: left;"><b>TNA Details</b></label> 
              </div><br> -->

              <!-- <div > -->
            
      <div class="col-md-12">
<b-col sm="12">

              <!-- <span><i  class="fa fa-2x fa-exclamation-circle " aria-hidden="true" style="color: #20a8d8; margin-left: 2px; font-size:14px;"></i>
              </span> <label style="color: red;font-size:14px;"> &nbsp;Please keep  cursor here for feedback from buyer .</label> -->
              <!-- <div class="col-md-12"> -->
                <!-- <div class="col-md-12">
                  <div class="col-md-12"> -->
                    
                <!-- <b-col sm="12"> -->

               <b-table  hover show-empty stacked="md" class="mt-4"  :outlined="outlined" :items="tnadata"  :fields="tnafields"
              :bordered="bordered"  > &nbsp; &nbsp;
          
             <template slot="activitiess" slot-scope="row">

               <span >{{row.item.activities}}</span>
              <!--  <span v-if="row.item.status==='feedback'" ><i  class="fa fa-comments-o" aria-hidden="true" :title="row.item.status" style="color: red; margin-left: 2px; font-size:24px;"></i></span> -->
               <span v-if="row.item.status==='feedback'"  style="color: #20a8d8; margin-left: 2px; font-size:10px;">
               <i class="fa fa-2x fa-exclamation-circle " :title="row.item.feedback" ></i></span>
                
               
            </template>
              <template slot="tnaactions" slot-scope="row">
                     <!-- <input type="file" @change="handleFileChange($event, index)"> -->
                

      <div  class='row' >
        
     <b-col class="pull-left">      
             
           

                <!-- Code With Step Number -->
                <b-form-file
                id="docuentselection"
                v-model="row.item.document"
                :disabled="row.item.status === 'Approved' || row.item.status==='Submitted' || row.item.status=='Actual_Approved' || row.item.status=='Actual_PartialApproved' || row.item.status=='Actual_Reject' && (step_no!=31 || step_no ==23 || step_no!=40 || step_no!=46 || step_no!=53 || step_no!=57)" 
                :state="Boolean(row.item.document)"
                placeholder="Upload Design File"  @change="handleFileChange($event,index,row.item)" required
                style="width: 100%;font-size:11px" v-if="step_no!=23 && step_no !=25 && step_no !=26 && step_no !=27 && step_no !=28 && step_no !=29 &&  step_no!=32 &&  step_no!=33 && row.item.activities!='PP Sample Submission' && row.item.activities=='Final Inspection'"
                >
              
                     <!--  Note: PP sample condition remove when pp sample approved from Buyer -->
                </b-form-file>
                <b-form-file
                id="docuentselection"
                v-model="row.item.document" class="add-style"
                :disabled="row.item.status === 'Approved' || row.item.status==='Submitted' || row.item.status=='Actual_Approved' || row.item.status=='Actual_PartialApproved' || row.item.status=='Actual_Reject' && (step_no!=31 || step_no ==23 || step_no!=40 || step_no!=46 || step_no!=53 || step_no!=57)" 
                :state="Boolean(row.item.document)"
                placeholder="Upload Design File"  @change="handleFileChange($event,index, row.item)" required
                style="width: 50%;pointer-events:none; background-color: #73818f" v-if="step_no ==23 || step_no==32 || step_no==33 || step_no ==25 || step_no ==26 || step_no ==27 ||step_no ==28 || step_no ==29">
                </b-form-file>

                 <button  type='button' 
                  style="margin-left: 20%;margin-top:2px;font-size:14px" class="btn btn-success " v-if=" 
                  row.item.status === 'approved' && (step_no>=31 || step_no!=32)  || row.item.activities=='Final Inspection'" @click="updatetnadetails(row.item,row.item.planned_achieve_date,row.item.actual_achieved_date,
                  $event)" ><i class="fa fa-save"></i>
                                   update
                 </button>
                              
          </b-col>  
        </div>
    
   

  
                              
                </template>
                <template v-if="row.item.status==='feedback'" slot="feedbackactions" slot-scope="row">
                  
                        {{row.item.status}}
             
                </template>


                              

                <template v-if="row.item.document !== '' "  slot="downloadactions" slot-scope="row">
                  
                  <a :href="row.item.document"  target="_blank"><i class="fa fa-download" aria-hidden="true" ></i></a>
             
                </template>

                <template slot="Planned_achieve_ Date" slot-scope="row">
                 <div>
            
                 <datepicker  slot="beforeCalendarHeader" class="calender-header" v-model="row.item.planned_achieve_date" :disabled="row.item.status !='feedback' && row.item.status!=''" id="planndate"   :format="DatePickerFormat" :disabledDates="disabledDates" name="date" placeholder="Select Date" v-validate="'required'" v-if="step_no==23 || step_no==32 || step_no==25 || step_no==26 || step_no==27 || step_no==28 || step_no==29"></datepicker>

                 <datepicker  slot="beforeCalendarHeader" class="calender-header" v-model="row.item.planned_achieve_date" id="planndate"  :disabled="(row.item.status === 'Approved' || row.item.status === 'Submited') && step_no ==31 || step_no !=23 || step_no !=32" :format="DatePickerFormat" :disabledDates="disabledDates" name="date" placeholder="Select Date" v-validate="'required'" v-if="step_no!=23 && step_no!=32 && step_no!=25 && step_no!=26 && step_no!=27 && step_no!=28 && step_no!=29"  style="pointer-events:none;"></datepicker>
                 <!-- Code With Step Number -->
<!-- step_no==23 || step_no==32 -->

               </div>

                 <span v-show="errors.has('date')" class="help is-danger-red">{{ errors.first('date') }}</span>
                              </template>
                              
                
                  <template slot="Actual_achieved_Date" slot-scope="row">

                     <datepicker slot="beforeCalendarHeader" :disabledDates="disabledDates" :disabled="(row.item.status === 'Approved' || row.item.status==='Submitted' || row.item.status=='Actual_Approved' || row.item.status=='Actual_PartialApproved' || row.item.status=='Actual_Reject') && (step_no!=31 || step_no ==23 || step_no!=40 || step_no!=46 || step_no!=53 || step_no!=57) " id="actuldate" v-model="row.item.actual_achieved_date"  placeholder="Select Date"  name="ActualachievedDate" v-if="step_no !=23 &&  step_no !=25 && step_no !=26 && step_no !=27 && step_no !=28 && step_no !=29 && step_no!=32 && step_no!=33 && row.item.activities!='PP Sample Submission' && row.item.activities=='Final Inspection' ">
                     <!--  Note: PP sample condition remove when pp sample approved from Buyer -->
                     </datepicker>
                    <!--  <datepicker slot="beforeCalendarHeader" :disabledDates="disabledDates" :disabled="row.item.status === 'Approved' || row.item.status==='Submitted' || row.item.status=='Actual_Approved' || row.item.status=='Actual_PartialApproved' || row.item.status=='Actual_Reject' && (step_no!=31 || step_no ==23 || step_no!=40 || step_no!=46 || step_no!=53 || step_no!=57) " id="actuldate" v-model="row.item.actual_achieved_date"  placeholder="Select Date"  name="ActualachievedDate" v-if=" row.item.activities!='Final Inspection'"  style="pointer-events:none;background-color: #73818f;">
                     </datepicker> -->
                     <datepicker slot="beforeCalendarHeader" :disabledDates="disabledDates" :disabled="true" id="actuldate" v-model="row.item.actual_achieved_date"  placeholder="Select Date"  name="ActualachievedDate" v-if="row.item.activities!='Final Inspection' "  style="pointer-events:none;background-color: #F0F0F0;">
                     </datepicker>
                     <!-- Code With Step Number -->
                    </template>

          </b-table>
        </b-col>
        </div>
        <!-- </b-col> -->
        <!-- </div>
      </div> -->
    </b-col>
        <!-- </b-col> -->
          <!-- </div> -->
            
          <!-- </div> -->
        </div>

</div>



 </b-row>    



   </div>


 
</template>

<script>

   import CONSTANTS from '@/utils/constants'
   import auth from '@/utils/auth'
   import Vue from 'vue'
   import Router from 'vue-router'
   import Utils from "@/utils";
   import swal from "sweetalert2";
   import Datepicker from 'vuejs-datepicker';
 
   import sidebarAllDesignsComponent from './_sidebarAllDesignsComponent.vue'
   import navbarMenu from './_navbarMenu.vue'
   
   const axios = require('axios')
   export default {
     name: 'Tabs',
     components: {
        sidebarAllDesignsComponent,
        navbarMenu,
        Datepicker,
      },  

     data () {
       return {
         addfile:false,
         showSideMenu:true,
         items: [],
         result: [],
         style_details:[],
         totalRows: 0,
         outlined:true,
         bordered: true,
         isBusy: false, 
         status_value: '',
         status: '',
         feedback: '',
         fields1: [
               {key: 'buyer_name', label: 'Buyer Name'}, 
               {key: 'vendor_name',label:'Vendor Name'}, 
               {key:'status' , label:'Status' },
               {key:'action' , label:'Action'}
              ],
         file_tab_status: false,
         fileupload_status: false,
         fileObj:[],
         disabled:true,
         disabledDates: {
        to: new Date(Date.now() - 8640000)
        },
         route_id: '',
         selected_vendor_id: 0,
         tnadata: [],
         feedback_arr:[],
         // updatetnadetails: false,
         comment: [],
         selectedbuyername: '',
         selectedvendorname:'',
         selectedstatus: '',
         activities: [],
         selected_status: '',
         selected_tna_id: 0,
         disabled_value: true,
         selected_activities_id: 0,
         selected_tna_id: 0,
         changed_status: '',
         tna_archivedaction_status: 'nochanged',
         selected_operational_status: '',
        // tnafields: [{key: 'activities', label: 'Activities'},
        //             {key: 'planned_achieve_date', label: 'Planned Achieve Date'},
        //             {key: 'actual_achieved_date',label:'Actual Achieved Date'},
                    
        //             {key:'actions' , label:'Action', tdClass: 'commonbtn'}],



         //Vendor Added Code
              isBusy: false,
      customer: {},
      outlined:true,
      bordered: true,
      perPage:  20,
      pageNum:1,
      noofpages:'',
      pageOptions: [5, 10, 15],
      sortBy: true,
    
     ModeOfTransport:'',
     ShippingCompanyName:'',
     TrackingId:'',
     ModeOfTransportpp:'',
     ShippingCompanyNamepp:'',
     TrackingIdpp:'',
      uplodeditems:[],
      message: 'Hello Vue.js!',
      dlvstatus:[],
      operational_status:'',
      img1:[],
      file: '',
      imgpath:[],
      selectedfilename:'',
      urlImg: [],
      planndate:[],
      planned_achieve_date:'',
      index:'',
      document:'',
      updatedisabled:true,
      disabled:true,
      savedisabled:false,
      plandisabled:false,
      ActualachievedDate:new Date(),
      plannedachivedate:new Date(),


        totalRows: 0,
        currentPage: 1,
        perPage:  10,
         sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
      route_id:'' ,
      state:[{
  date: new Date(2016, 9,  16)
}],
       customlogdata: [],
       smslogdata: [],
       
        tnadata:[],
      

    
tnafields: [{key: 'activitiess', label: 'Activities', tdClass: 'activityClass'}, {key: 'Planned_achieve_ Date', label: 'Planned Achieve Date'},
{key: 'Actual_achieved_Date',label:'Actual Achieved Date',tdClass: 'actualdateClass'},
{key:'feedback' , label:'Feedback' ,tdClass: 'feedbackClass'},
{key:'tnaactions' , label:'Upload Proof Documents' ,tdClass: 'uploadClass'}],

        purchacedetailsitems: [
          { po_id: '123', warehouse_name: 'chakan', created_date: '10/4/9',status: 'approved' },
          { po_id: '145', warehouse_name: 'hadpsar', created_date: '10/4/9',status: 'dispatched' },
          { po_id: '234', warehouse_name: 'pune', created_date: '10/4/9',status: 'rejected' },
          { po_id: '555', warehouse_name: 'banglore',created_date: '10/4/9', status: 'pending' },
          

        ],

    
       purchacedetailsfields: [{key: 'po_id', label: 'po id'},{key: 'warehouse_name', label: 'warehouse name'},{key: 'created_date',label:'created date'}, {key: 'status',label:'Status'},{key:'purchacedetailsctions' , label:'Action' }],

      ConsignmentMasterGetdata: [],
      step_no: 0,
      isConsignmentActivityTrackingGetWeb: 0,
      isConsignmentMasterGetStatus: 0,
      isGetlogisticlogdetails: 0,
      DatePickerFormat: 'dd/MM/yyyy',
      disabledDates: {
        to: new Date(Date.now() - 8640000)
        },
        progress: 0,
        remoteUrl: '',
        currentFile: '',
        message:'',

        //Vendor Added Code Ends

        }  

       
     },
     created: function() { 
      this.getdesigndetail();
      this.tnadetails();
      this.route_id=this.$route.params.id;
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;
      var userData = localStorage.getItem('userData');
      if(userData) 
      {
        this.quote_tab=true;
        this.message_tab=true;
      }
      //Added Code
     // document.getElementById("actuldate").disabled = true;
      //Added Code Ends

     },
       methods: { 
       checkdocument: function(event){
      if(event==''){
        // alert("Please Select File");
        this.$fire({
                    text:"Please Select File",
                    type: "warning",
                    timer: 30000
                      }) 
      }
    },
    clear: function(){
      this.remoteUrl='';
      this.selectedfilename= '';
    },
  tnadetails: function() {
    // document.getElementById("overlay").style.display = "block";
       //alert(" i m tnadetails listing");
      var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
            this.vendor_id = userInfo[0].vendor_id;
      const Obj = {
                  
                vendor_id:this.vendor_id,
                 style_id:this.route_id
                  
                  }


              axios.post(`${CONSTANTS.API_URL}/getTNADetails`,Obj)
                .then(response => {
                  this.result = response.data

                  if (this.result.returnmsg === 'Successful') {
                    this.tnadata = this.result.returnvalue;
                
                  // document.getElementById("overlay").style.display = "none";
                  // if(this.tnadata[0].status ==='Submited')

                  //      {

                  //      }
                    // console.log(this.tnadata);

         
                    
                  }
                 

                })
                .catch(e => {
                  this.errors.push(e)
                })
     
    }, 
      opentnaModal(value) {
        this.status= '';       
        // this.getdesigndetail();
        // this.updatetnadetails =true;
        
 },
        //Function for row data
        getrowdata(value){
          this.selected_tna_id = value.tna_id;
        },
        //Function for row data ends
        //Function for TNA action
        achivedtnaaction: function(status,tna_id,activities_id){
          // alert("In");
          // alert(status);
          this.selected_status=status;
          this.selected_tna_id=tna_id;
          this.selected_activities_id=activities_id;
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)

          // if(confirm("Are you sure you want to "+status+"?")){  
            const Obj={
            tna_status: status,
            tna_id: tna_id,
            activities_id: activities_id,
            style_id: this.$route.params.id,
            updated_by: userInfo[0].email_id
          }
          // alert(tna_id);

           

          axios.post(`${CONSTANTS.API_URL}/achivedTNADetailStatus`,Obj)
          .then((result) => {
            document.getElementById("overlay").style.display = "none";
            console.log("SSSSSSSSSSS",result);  
            if(result.data.returnmsg=='Successful'){
              // alert("TNA updated Sucessfully");
              this.$fire({
                      text:" TNA updated Sucessfully.",
                      type: "success",
                      timer: 30000
                            })
              this.tnadetails();
              this.getdesigndetail();
              
              // this.tnadetails();
              // this.getdesigndetail();
            }      
            else{
              // alert(result.body.returnmsg);
              this.$fire({
                      text:result.body.returnmsg,
                      type: "error",
                      timer: 30000
                            })
              this.tna_archivedaction_status = "nochanged";
            }
          })
          .catch((ex) => {
            console.log('error', ex)
          })
          //}
         
          
        },
        //Function for TNA action ends

        //Function for Feedback
        getfeedback: function(index,activities_id,tna_id,comment){
          this.feedback_arr.push({
            feedback: this.comment[index],
            activities_id: activities_id,
            tna_id: tna_id
          });

        },//function ends

        //Function for update TNA status
        updatetnastatus: function(value){
          document.getElementById("overlay").style.display = "block";
          if(value!='feedback'){
              this.feedback_arr=this.tnadata
          }
          
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          var recarr=[];

          recarr=this.selectedVendor;
          const Obj={
              status: value,
              style_id: this.$route.params.id,
              tna: this.feedback_arr,
              updated_by: userInfo[0].email_id,
              // feedback: this.feedback_arr
          }
          console.log("UUUUUUUUUUUUUU",Obj);
          // style_id->143
        //agentmaster
        // return false;
        axios.post(`${CONSTANTS.API_URL}/updatetnastatus`,Obj)
          .then((result) => {
            document.getElementById("overlay").style.display = "none";
            console.log("SSSSSSSSSSS",result);  
            if(result.data.returnmsg=='Successful'){
              // alert("TNA updated Sucessfully");
               this.$fire({
                      text:"TNA updated Sucessfully",
                      type: "success",
                      timer: 30000
                            })
              this.achivedtnaaction(this.selected_status,this.selected_tna_id,
              this.selected_activities_id);
              this.getdesigndetail();
              this.tnadetails();
              
              this.getdesigndetail();
              this.$router.go(0)
              // this.tnadetails();
            }      
            else{
              // alert(result.body.returnmsg);
              this.$fire({
                      text:result.body.returnmsg,
                      type: "error",
                      timer: 30000
                            })
            }
          })
          .catch((ex) => {
            console.log('error', ex)
          })
        },
        //function ends
        // Function for open txt box for feedback
        opentextfunction: function(value){
          //alert(value);
          this.status_value= value;
          
        },
        //function ends

       /****** Function to design details ********/
       getdesigndetail: function () {
           this.isBusy = true;
       
           const Obj = {
                style_id: this.$route.params.id,              
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";

             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
              console.log("RRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR",this.result)
            this.style_details  = this.result.returnvalue[0];
            this.selected_vendor_id= this.style_details.vendor_id;
            this.selected_operational_status= this.style_details.operational_status;
            this.selectedvendorname = this.style_details.vendor_name;
            this.selectedbuyername = this.style_details.buyer_name;
            this.selectedstatus = this.style_details.design_status;
            this.totalRows = this.result.returnvalue.length;
            this.operational_status=this.result.returnvalue[0].operational_status;
            this.step_no = this.style_details.status_code_number;
         // alert(this.operational_status);
                    if(this.operational_status ==='TNA-Approved')
                    {
                      
                  this.disabled = false;
                  this.updatedisabled=false;
                  // this.savedisabled=true;
                  // this.plandisabled=true;
                  }

            this.tnadetails();
            for(var i=0;i<=this.totalRows;i++){
              if(this.style_details.status_code_number>=8){
                this.file_tab_status =true;
                
              }
            }
            }

           })
           .catch(e => {
             this.errors.push(e)
           })
   
   
       },
            handleFileChange(evt, index, value) {
              console.log("IIIIIIIIIIIIIIIIIIIIIIIII",value);
              // return false;
        document.getElementById("overlay").style.display = "block";
      
     // console.log(this.selectedfilename);  
  
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      let data = new FormData();
      let file = event.target.files[0];
      this.selectedfilename= file;
      console.log(file);
      data.append('file_name', file)
      data.append('tna_id', value.tna_id)
      // data.append('user_id',userInfo[0].vendor_id)
      let config = {
        header : {
         'Content-Type' : 'multipart/form-data'
       }
      }
      // Nazafat Code Start
      this.progress=0
      this.currentFile=file;

      axios.post(`${CONSTANTS.API_URL}/uploadfilefortna`,data, config)
       .then(response => {
        this.progress = Math.round((100 * response.loaded) / response.total);
        document.getElementById("overlay").style.display = "none";
        this.remoteUrl = response.data.url;
        // this.getdesigndetail();
      }).then(response =>{
        this.message=response.data.message;
      })
       .catch((err) =>{
          return new Error(err.message);
          this.progress=0;
          this.message="Could not upload the file!";
          this.currentFile='';
        })

    },
    //new ends 


 savePlanned: function(plaaned_data) {
document.getElementById("savedate").style.display = "none";
// console.log("YYYYYYYYYYYYYYYYY",plaaned_data);
  // if(this.step_no==23){
  // for(var i=0;i<=plaaned_data.length;i++){
  //   if(plaaned_data[i].planned_achieve_date==''){
  //     alert("Please Select All Planned Date");
  //     document.getElementById("savedate").style.display = "none";
  //     // this.$router.go(0)
  //     // return false;
  //   }
  // }
  // }
  // this.$validator.validateAll(scope).then((result) => {


// var data = [];
//   plaaned_data.forEach(function(i, val) {
  
    
//        data.push({
//                     activity:i.activities,
//                    plaanneddate:this.formatDate(i.planned_achieve_date)
//                  });
// }, this);


 var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
            this.vendor_id = userInfo[0].vendor_id;

var data = [];
              plaaned_data.forEach(function (srData,val) {
             var plannedachivedatee = this.formatDate(srData.planned_achieve_date);
             
                // alert(plaaned_data.activities_id);
                data.push({
            
                  

                 
                 activities_id:srData.activities_id,
                   activities:srData.activities,
                    style_id:this.route_id,
                 vendor_id:this.vendor_id,
                  tna_id: srData.tna_id,
                  planned_achieve_date:plannedachivedatee,
                  updated_by: userInfo[0].email_id,
                });
              },this);
              console.log(data);

    axios.post(`${CONSTANTS.API_URL}/submitPlannedDateInTNA`,data)
                .then(response => {
                  this.result = response.data
                   // alert(this.result);
                 if (this.result.returnmsg === 'Inserted Successful') {
                    // alert("Data Saved Successfully");
                     this.$fire({
                    text:"Data Saved Successfully.",
                    type: "success",
                    timer: 30000
                      }) 
                    // this.$router.go(0)
                     this.tnadetails();
                     this.$router.go(-1)
                     // this.$router.push({ name: 'tna', params: { id: this.route_id } })
                     // this.tnadetails();
                    // this.$router.push({ name: 'tna', params: { this.route_id } })
                  //this.tnadetails();

                    // Utils.notify("Data Saved Successfully", "success");
                    
                  }
                  else if(this.result.returnmsg === 'Updated Successful'){
                    // alert("Data Updated Successfully");
                     this.$fire({
                    text:"Data Updated Successfully.",
                    type: "success",
                    timer: 30000
                      }) 
                    // this.$router.go(0)
                     this.tnadetails();
                     this.$router.go(-1)
                    // this.$router.push({ name: 'tna', params: { id: this.route_id } })
                    // this.$router.push({ name: 'tna', params: { this.route_id } })
                  }
                 


                })
                .catch(e => {
                  this.errors.push(e)
                })




      // })
 },

 formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },


      updatetnadetails: function(value,planned_date,actul_date,document) {
        // document.getElementById("overlay").style.display = "block";

        console.log("555555555555555",document);
        // alert(this.selectedfilename);
        // console.log(this.selectedfilename);
        if(actul_date != null && this.remoteUrl!= "")
        {
          
        
        // document.getElementById("overlay").style.display = "block";
        
        console.log(planned_date);
      console.log(actul_date);
      

      if((planned_date=='') && (actul_date==''))
      {
       
        // alert("please provide atlest one filed ");
             var plannedachivedatee = '';
             var ActualachievedDate = '';
            
      }
     
      else
        if((actul_date=='') || (actul_date==null))
      {

        
             var plannedachivedatee = this.formatDate(planned_date);
             var ActualachievedDate = ''
            
      }
      else 
      if((planned_date=='') || (actul_date==null))
      {
        
             var plannedachivedatee = ''
             var ActualachievedDate = this.formatDate(actul_date);
            
      }

      else
      {
             var plannedachivedatee = this.formatDate(planned_date);
             var ActualachievedDate = this.formatDate(actul_date);
      }
      // alert(value.activities);
          var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
            this.vendor_id = userInfo[0].vendor_id;
             //  var plannedachivedatee = this.formatDate(planned_date);
             // var ActualachievedDate = this.formatDate(actul_date);
      

     let data = new FormData();
      let file = this.selectedfilename;
      // console.log("WWWWWWWWWWWWWWWW",file.type);
      //data.append('name', 'my-file')
      data.append('file', file)
      data.append('tna_id',value.tna_id)
      data.append('vendor_id',this.vendor_id)
      data.append('style_id',this.route_id)
      data.append('activities_id',value.activities_id)
      data.append('activities',value.activities)
      data.append('planned_achieve_date',`${plannedachivedatee}`)
      data.append('actual_achieved_date',`${ActualachievedDate}`)
      
 

      let config = {
        header : {
         'Content-Type' : 'multipart/form-data'
       }
      }

         
      const Obj = {
                  tna_id:value.tna_id,
                vendor_id:this.vendor_id,
                 style_id:this.route_id,
                 activities_id:value.activities_id,
                 planned_achieve_date:`${plannedachivedatee}`,
                 actual_achieved_date:`${ActualachievedDate}`,
                 activity_title:value.activities,
                 updated_by: userInfo[0].email_id,
                  }
console.log("Ppppppppppppppppppp",Obj);
//                   "tna_id":988,
// "vendor_id":401,
// "style_id":"344",
// "activities_id":2,
// "planned_achieve_date":"2021-02-16",
// "actual_achieved_date":"2021-02-02",
//   "activity_title":"FPT Submission"
                  // console.log(data)       
// data,config
// return false;
              axios.post(`${CONSTANTS.API_URL}/updateTNAAchiveDates`,Obj)
                .then(response => {
                  this.result = response.data
                   // alert(this.result);
                 if (this.result.returnmsg === 'Successful') {
                  // document.getElementById("overlay").style.display = "none";
                    // alert("Data Saved Successfully");
                      this.$fire({
                    text:"Data Saved Successfully.",
                    type: "success",
                    timer: 30000
                      }) 
                    this.tnadetails();
                    this.remoteUrl='';
                  // this.updatedisabled=true;
                  // document.getElementById("overlay").style.display = "none";
                    // Utils.notify("Data Saved Successfully", "success");
                    
                  }
                 


                })
                .catch(e => {
                  this.errors.push(e)
                })
}
else
{
  // alert("Please Select both ActualachievedDate & upload Documents ")
    this.$fire({
                text:"Please Select both ActualachievedDate & Upload Documents ",
                type: "warning",
                timer: 30000
                      }) 
}
    },

         tnadetails: function() {
      var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
      const Obj = {

               vendor_id:this.selected_vendor_id,
               // vendor_id: 401,
                 style_id:this.$route.params.id
                  }

              axios.post(`${CONSTANTS.API_URL}/getTNADetails`,Obj)
                .then(response => {
                  this.result = response.data

                  if (this.result.returnmsg === 'Successful') {
                    this.tnadata = this.result.returnvalue;
                    for(var i=0;i<this.tnadata.length;i++){
                      this.comment[i]=this.tnadata[i].feedback;
                    }
                    
                    this.isBusy = !this.isBusy;
                  }
                  else
                  {
                    this.tnadata = this.result.returnvalue;
                    this.isBusy = !this.isBusy;
                  }


                })
                .catch(e => {
                  this.errors.push(e)
                })

    }, 


        onClose() {
            this.visible = false;
        },

     }
   }
</script>
<style>
   .short-div {
   height:55px;
   }


.quote-dropdowns .dropdown--accepted {
    border-top: 1px solid var(--fill-green-dark);
}

.quote-dropdowns>.card {
    background-color: var(--fill-white);
}
.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}
.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .dropdown__header {
    align-items: center;
    justify-items: center;
    justify-content: center;
    cursor: pointer;
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}
.f-sz-l {
    font-size: 15px;
}
.flex-col {
    flex-direction: column;
}
.flex, .flex-col {
    display: flex;
}
.f-w-semi-bold {
    font-weight: 600;
}
.f-sz-sm {
    font-size: 12px;
}
.f-w-semi-bold {
    font-weight: 600;
}   

.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}

.input-grp {
    width: 100%;
    margin-bottom: 16px;
}
.input-grp {
    margin-bottom: 10px!important;
}

.input-grp label {
    margin-bottom: 6px;
    color: #333340;
}

input[type=number], input[type=password], input[type=tel], input[type=text] {
    padding: 13px 12px;
    border-radius: 2px;
    border: 1px solid #bfbfbf;
}
.input-grp input, .input-grp label, .input-grp select {
    display: block;
    width: 100%;
}

.input-grp select:disabled {
    background-color: #ebebe4;
}
.input-grp select {
    background: url(/static/media/ic-arrow-drop-down.1f6abe65.svg) no-repeat;
    background-position: right 8px top 6px;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
}

.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}

  .brand-card{
   border-radius:0px !important;
  }

     .sidebar{
   background: #17a2b8!important;
   width:50px !important;
   }

   .sidebar .sidebar-nav{
    width:50px !important;
   }
   .sidebar .nav{
    width:50px !important;
   }

   .main{
    margin-left:50px !important;
   }
   #rec_msg{    
    margin-left: 40%;
    position: absolute;
   }


/*** Tabb ***/
.header-tabs__navbar {
    margin-top: auto;
    align-items: center;
    border-top: 1px solid var(--fill-grey-light2);
}
.flex {
    display: flex;
}

.header-tabs__tab {
    position: relative;
    flex: 1 1;
    height: 43px !important;
    padding: 12px 22px;
    border-bottom: 3px solid var(--fill-grey-light3);
    display: flex;
    flex-direction: row;
    cursor: pointer;
    border: 1px solid #63c2de;
    border-radius: 12px;
}

.header-tabs__tab-image {
    padding-right: 8px;
}

.header-tabs__tab-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
 
.header-tabs__tab .sub_title {
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    font-weight: 400;
    color: var(--fill-grey-medium);
} 



html, body {
  margin: 0
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color:white
}

/*Todays CSS*/
.nav_row_tabs {
 
  display: flex;
  border-top: 1px solid #D7DBDD;
  border-bottom: 1px solid #D7DBDD;
}

  #activeTitle{
  font-size: 14px;
}
.t_cell{
  word-wrap: break-word; 
  column-width: fixed;
  max-width: 250px !important;
}
.commonbtn{
  align-items: center;
  ​rowspan:2;
  max-width: 200px;

}
.btn_download{
  background: none;
}
 /* .b-table-caption-top{
    color: black;
  }*/
/*.table button {
    background: #f6f7f9!important;
    color: white!important;
    border: none;
}*/
 .uploadClass {
   width: 430px !important;
}
.actualdateClass{
  width: 150px !important;
}
.activityClass{
  width: 200px !important;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.blink {
      animation: blink 2s steps(5, start) infinite;
      -webkit-animation: blink 1s steps(5, start) infinite;
    }
    @keyframes blink {
      to {
        visibility: hidden;
      }
    }
    @-webkit-keyframes blink {
      to {
        visibility: hidden;
      }
    }
    .feedbackClass{
      width: 200px;
      word-wrap: break-word; 
      column-width: fixed;
      /*max-width: 500px !important;*/

    }
    .add-style label {

background-color: #E0E0E0;

}
</style>
